import httpClient from "./httpClient";

const base = "/subject-assign-to-teacher";

export function listSubjectAssignToTeachers() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function assignSubjectToTeacher(staffId, classConfigId, subjectIds) {
  const params = new URLSearchParams();
  params.append("staffId", staffId);
  params.append("classConfigId", classConfigId);
  subjectIds.forEach((id) => params.append("subjectIds", id));
  return httpClient.post(`${base}?${params.toString()}`).then((res) => res.data);
}

export function deleteSubjectAssignToTeacher(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}

export function deleteAllSubjectAssignToTeacherForStaff(staffId) {
  return httpClient.delete(`${base}/staff/${staffId}`).then((res) => res.data);
}
